// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./Toggle.css";
// import ravlogo from "../../assets/img/logo1.png";
// import organic from "../../assets/img/image.png";
// import { useDispatch } from "react-redux";
// import { uiAction } from "../../Redux/Slices/uiSlice";
// import ButtonGotoDash from "../../Shared/ButtonGotoDash/ButtonGotoDash";
// const DashboardToggle = () => {
//   const [isEcommerce, setIsEcommerce] = useState(false);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const handleToggle = () => {
//     setIsEcommerce(!isEcommerce);
//   };
//   const goToDashboard = () => {
//     if (isEcommerce) {
//       dispatch(uiAction.updateAppType("Ecommerce"));
//     } else {
//       dispatch(uiAction.updateAppType("Business"));
//     }
//     navigate("/dashboard", { replace: true });
//   };
//   return (
//     <div className={` ${isEcommerce ? "toggle-page " : "toggle-page "}`}>
//       <div className="toggle-card">
//         <div className="headingColor title">Select Your Dashboard</div>
//         <div className="toggle-switch">
//           <input
//             type="checkbox"
//             id="dashboardToggle"
//             checked={isEcommerce}
//             onChange={handleToggle}
//           />
//           <label
//             htmlFor="dashboardToggle"
//             className={`slider d-flex ${
//               isEcommerce ? "justify-content-start" : "justify-content-end"
//             }  align-items-center`}
//           >
//             <span className="icon-wrapper">
//               {isEcommerce ? (
//                 <img className=" w-100" src={organic} alt="" />
//               ) : (
//                 <img className="w-100 rounded-circle" src={ravlogo} alt="" />
//               )}
//             </span>
//             <span
//               className={
//                 isEcommerce
//                   ? " ecommerce text-white me-3  fw-bold"
//                   : " associate fw-bold  text-white ms-3"
//               }
//             >
//               {isEcommerce ? "Ecommerce" : "Property"} Dashboard
//             </span>
//           </label>
//         </div>
//         <ButtonGotoDash
//           removeIcon={true}
//           className={`${isEcommerce ? "btn btn-org" : "btn btn-property"} `}
//           text={"Go to Dashboard"}
//           handleClick={goToDashboard}
//         />
//       </div>
//     </div>
//   );
// };
// export default DashboardToggle;

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { uiAction } from "../../Redux/Slices/uiSlice";
import ButtonGotoDash from "../../Shared/ButtonGotoDash/ButtonGotoDash";

// Assets
import ravlogo from "../../assets/img/logo1.png";
import organic from "../../assets/img/image.png";

// CSS Module
import styles from "./DashboardToggle.module.css";

const DashboardToggle = () => {
  const [isEcommerce, setIsEcommerce] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleToggle = () => {
    setIsEcommerce(!isEcommerce);
  };

  const goToDashboard = () => {
    const type = isEcommerce ? "Ecommerce" : "Business";
    dispatch(uiAction.updateAppType(type));
    navigate("/dashboard", { replace: true });
  };

  return (
    // The container's background image changes based on state
    <div
      className={`${styles.container} ${
        isEcommerce ? styles.bgEcommerce : styles.bgProperty
      }`}
    >
      <div className={styles.card}>
        <div className={styles.title}>
          {isEcommerce ? "Ecommerce" : "Property"} Dashboard
        </div>

        {/* The Toggle Switch */}
        <div className={styles.switchContainer} onClick={handleToggle}>
          {/* 1. The Sliding Knob */}
          <div
            className={`${styles.knob} ${isEcommerce ? styles.knobRight : ""}`}
          >
            <img src={isEcommerce ? organic : ravlogo} alt="icon" />
          </div>

          {/* 2. The Text Labels (Property | Ecommerce) */}
          <div className={styles.trackLabels}>
            <span className={`${styles.label} ${styles.labelActive}`}>
              {!isEcommerce ? "" : "Property"}
            </span>
            <span className={`${styles.label} ${styles.labelActive}`}>
              {!isEcommerce ? "Ecommerce" : ""}
            </span>
          </div>
        </div>

        {/* Action Button */}
        <ButtonGotoDash
          removeIcon={true}
          className={`${styles.btnBase} ${
            isEcommerce ? styles.btnEcommerce : styles.btnProperty
          }`}
          text={`Enter To ${isEcommerce ? "Ecommerce" : "Property"}`}
          handleClick={goToDashboard}
        />
      </div>
    </div>
  );
};

export default DashboardToggle;
